import React from 'react';
import { Link, useParams } from 'react-router-dom';
import './Header.css';  // Add this import

const categories = ['Domaci', 'Zahranicni', 'Ekonomika', 'Technika', 'Kultura', 'Sport'];

const displayCategoryMap: { [key: string]: string } = {
  Domaci: 'Domácí',
  Zahranicni: 'Zahraniční',
  Ekonomika: 'Ekonomika',
  Technika: 'Technika',
  Kultura: 'Kultura',
  Sport: 'Sport',
};

const positivityHints = [
  'velmi negativní',
  'silně negativní',
  'negativní',
  'mírně negativní',
  'spíše negativní',
  'neutrální',
  'spíše pozitivní',
  'mírně pozitivní',
  'pozitivní',
  'silně pozitivní',
  'velmi pozitivní'
];

interface HeaderProps {
  sliderValue: number;
  setSliderValue: (value: number) => void;
}

const Header: React.FC<HeaderProps> = ({ sliderValue, setSliderValue }) => {
  const { categoryName } = useParams<{ categoryName: string }>(); // Get the selected category

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    setSliderValue(value);
    const valuePercent = (value / 9 * 100) + '%';
    e.target.style.setProperty('--value', (value / 9).toString());
    e.target.style.setProperty('--value-percent', valuePercent);
  };

  return (
    <header className="site-header">
      <div className="header-content">
        <Link to="/" className="header-logo-link">
          <img src="/logo4.png" alt="Logo" className="header-logo" />
          <h1 className="header-title">Dobré zprávy dnes</h1>
        </Link>
        <nav className="header-nav">
          <ul className="header-categories">
            {categories.map((category) => (
              <li key={category} className={`header-category-item ${categoryName === category ? 'selected' : ''}`}>
                <Link to={`/category/${category}`} className="header-category-link">
                  {displayCategoryMap[category]}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="slider-container centered">
          <label htmlFor="positivity-slider">Negativní</label>
          <input
            type="range"
            id="positivity-slider"
            min="0"
            max="9"
            value={sliderValue}
            onChange={handleSliderChange}
            style={{
              '--value': sliderValue / 9,
              '--value-percent': `${(sliderValue / 9) * 100}%`
            } as React.CSSProperties}
          />
          <label htmlFor="positivity-slider">Pozitivní</label>
        </div>
        <div className="positivity-text">
          <p>Zobrazovat články od {positivityHints[sliderValue]} do velmi pozitivní</p>
        </div>
      </div>
    </header>
  );
};

export default Header;

// Add this line to make it a module
export {};
